import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";
import { getStoredConsent, trackMicroConversion } from "@/lib/tracking";

// Schlanke Kontakt-Leiste am unteren Bildschirmrand – nur mobil (unter lg).
// Erscheint erst nach etwas Scrollen und sobald die Consent-Frage beantwortet wurde.
const MobileQuickContact = () => {
  const [scrolled, setScrolled] = useState(false);
  const [consentDone, setConsentDone] = useState(() => getStoredConsent() !== null);
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 500);
    const onConsent = () => setConsentDone(true);
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("ftd-consent-changed", onConsent);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("ftd-consent-changed", onConsent);
    };
  }, []);

  const visible = scrolled && consentDone;

  const goToForm = () => {
    trackMicroConversion("cta");
    if (pathname === "/freie-trauung-krefeld") {
      document.getElementById("anfrage")?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/freie-trauung-krefeld");
      setTimeout(() => {
        document.getElementById("anfrage")?.scrollIntoView({ behavior: "smooth" });
      }, 500);
    }
  };

  return (
    <>
      {/* Abstandshalter, damit die fixierte Leiste keinen Footer-Inhalt verdeckt */}
      <div className="h-16 lg:hidden" aria-hidden="true" />
      <div
        data-testid="mobile-quick-contact"
        aria-hidden={!visible}
        className={`fixed inset-x-0 bottom-0 z-40 border-t border-sand bg-creme/95 backdrop-blur-md transition-transform duration-500 lg:hidden ${
          visible ? "translate-y-0" : "translate-y-full"
        }`}
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="flex gap-3 px-4 py-3">
          <a
            href={CONTACT.phoneHref}
            data-testid="quick-call-button"
            onClick={() => trackMicroConversion("phone")}
            tabIndex={visible ? 0 : -1}
            className="flex flex-1 items-center justify-center gap-2 rounded-full border border-stone/40 py-3.5 text-sm font-bold text-ink transition-colors duration-300 hover:border-moss hover:text-moss"
          >
            <Phone size={16} /> Anrufen
          </a>
          <button
            type="button"
            data-testid="quick-request-button"
            onClick={goToForm}
            tabIndex={visible ? 0 : -1}
            className="flex flex-[1.4] items-center justify-center gap-2 rounded-full bg-moss py-3.5 text-sm font-bold text-creme transition-colors duration-300 hover:bg-mossdeep"
          >
            Kennenlerngespräch <ArrowRight size={15} />
          </button>
        </div>
      </div>
    </>
  );
};

export default MobileQuickContact;
